import { render, staticRenderFns } from "./ExamLowestScore.vue?vue&type=template&id=47efdf7b&scoped=true"
import script from "./ExamLowestScore.vue?vue&type=script&lang=js"
export * from "./ExamLowestScore.vue?vue&type=script&lang=js"
import style0 from "./ExamLowestScore.vue?vue&type=style&index=0&id=47efdf7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47efdf7b",
  null
  
)

export default component.exports